import { WizardStatus } from '../../../../../../domain/wizard/wizard'
import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type IchraBenefitDesignWizardStateResponse = {
  id: string
  name: string
  reimbursementProduct?: number
  offerSameAllowance?: boolean
  waitingPeriod?: number
  wizardStatus: WizardStatus
}

export const getIchraProductClassDesignWizardState = (
  productClassId: string,
): Promise<IchraBenefitDesignWizardStateResponse> => {
  return adminHttpClient.get(`/AdminDashboard/ichra/ClassDesignWizardState/${productClassId}`)
}

export const mockGetIchraProductClassDesignWizardState = (
  productClassId: string,
): Promise<IchraBenefitDesignWizardStateResponse> => {
  return Promise.resolve({
    id: '1',
    name: 'Full Time',
    wizardStatus: WizardStatus.InProgress,
  })
}
